import React from 'react';

import { IIconProps, TIconType } from '../interface';

const TriangleRightIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='triangle-right'
			fill='none'
			height='20'
			viewBox='0 0 20 20'
			width='20'
		>
			<path
				d='M12.5 10L7.5 15L7.5 5L12.5 10Z'
				fill={props?.color || '#2E2E6B'}
			/>
		</svg>

	);
};

export default TriangleRightIcon;
